export const FETCH_MARKET_PRICING_START = "FETCH_MARKET_PRICING_START";
export const FETCH_MARKET_PRICING_SUCCESS = "FETCH_MARKET_PRICING_SUCCESS";
export const FETCH_ORDER_BOOK_START = "FETCH_ORDER_BOOK_START";
export const FETCH_ORDER_BOOK_SUCCCESS = "FETCH_ORDER_BOOK_SUCCCESS";